import { ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";

const Navbar = () => {
  const { count, setOpen } = useCart();

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-xl border-b border-gold/20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-baseline gap-2">
          <span className="font-serif-lux text-3xl font-semibold tracking-[0.25em] text-charcoal">ALTIUS</span>
          <span className="hidden sm:inline text-[10px] tracking-[0.3em] uppercase text-gold">Wellness · Recovery</span>
        </a>

        <nav className="hidden md:flex items-center gap-10 text-sm tracking-widest uppercase text-charcoal/70">
          <a data-testid="nav-shop-link" href="#shop" className="gold-underline hover:text-charcoal transition-colors">Shop</a>
          <a data-testid="nav-why-link" href="#why" className="gold-underline hover:text-charcoal transition-colors">Why Altius</a>
          <a data-testid="nav-reviews-link" href="#reviews" className="gold-underline hover:text-charcoal transition-colors">Reviews</a>
        </nav>

        <button
          data-testid="cart-open-button"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 px-5 py-2.5 rounded-full border border-gold/40 text-charcoal hover:bg-gold hover:text-charcoal transition-colors duration-300"
        >
          <ShoppingBag size={18} strokeWidth={1.5} />
          <span className="text-sm tracking-widest uppercase hidden sm:inline">Cart</span>
          {count > 0 && (
            <motion.span
              key={count}
              initial={{ scale: 0.4 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 500, damping: 15 }}
              data-testid="cart-count-badge"
              className="absolute -top-2 -right-2 bg-gold text-charcoal text-xs font-semibold w-6 h-6 rounded-full flex items-center justify-center"
            >
              {count}
            </motion.span>
          )}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
